/**
 * cutImg不能能压缩图片，只是裁剪了图片
 * @param fileObj [type: object] [比如e.target.files[0]]
 * @param callback [type: fn] [回调函数，比如调用上传接口]
 */
export const cutImg = function (fileObj, callback) {
    if (typeof (FileReader) === 'undefined') {
        console.error('当前浏览器内核不支持base64图标压缩');
        //调用上传方式不压缩
        directTurnIntoBase64(fileObj, callback);
    } else {
        try {
            let reader = new FileReader();
            reader.onload = function (e) {
                let image = document.createElement('img');
                image.onload = function () {
                    let square = 700;   //定义画布的大小，也就是图片压缩之后的像素
                    let canvas = document.createElement('canvas');
                    let context = canvas.getContext('2d');
                    let imageWidth = 0; //压缩图片的大小
                    let imageHeight = 0;
                    let offsetX = 0;
                    let offsetY = 0;

                    canvas.width = square;
                    canvas.height = square;
                    context.clearRect(0, 0, square, square);

                    if (this.width > this.height) {
                        imageWidth = Math.round(square * this.width / this.height);
                        imageHeight = square;
                        offsetX = -Math.round((imageWidth - square) / 2);
                    } else {
                        imageHeight = Math.round(square * this.height / this.width);
                        imageWidth = square;
                        offsetY = -Math.round((imageHeight - square) / 2);
                    }
                    context.drawImage(this, offsetX, offsetY, imageWidth, imageHeight);
                    var data = canvas.toDataURL('image/jpeg');
                    //压缩完成执行回调
                    callback(data);
                };
                image.src = e.target.result // 必须赋值给src属性，比如img的onload都不执行
            };
            reader.readAsDataURL(fileObj);
        } catch (e) {
            console.error('压缩失败');
            //调用直接上传方式  不压缩
            directTurnIntoBase64(fileObj, callback);
        }
    }
};

/**
 * directTurnIntoBase64不对图片进行压缩，直接转成base64
 * @param fileObj
 * @param callback
 */
export const directTurnIntoBase64 = function (fileObj, callback) {
    let r = new FileReader();
    // 转成base64
    r.onload = function () {
        //变成字符串
        let base64 = this.result;
        callback(base64);
    };
    r.readAsDataURL(fileObj);    //转成Base64格式
};

/**
 * compress能压缩图片
 * @param fileObj [type: object] [比如e.target.files[0]]
 * @param obj [type: object] [比如传入{quality:0.7}，设置压缩后的质量]
 * @param callback [type: fn] [回调函数，比如调用上传接口]
 */
export const compress = function (fileObj, obj, callback) {
    if (!fileObj) return;
    if (fileObj.size / 1024 > 1025) {
        // 大于1M，进行压缩上传
        try {
            let reader = new FileReader();
            reader.onload = function (e) {
                let image = document.createElement('img');
                image.onload = function () {
                    let that = this;
                    // 默认按比例压缩
                    let w = that.width,
                        h = that.height,
                        scale = w / h;
                    w = obj.width || w;
                    h = obj.height || (w / scale);
                    let quality = 0.7;  // 默认图片质量为0.7
                    //生成canvas
                    let canvas = document.createElement('canvas');
                    let ctx = canvas.getContext('2d');
                    // 创建属性节点
                    let anw = document.createAttribute("width");
                    anw.nodeValue = w;
                    let anh = document.createAttribute("height");
                    anh.nodeValue = h;
                    canvas.setAttributeNode(anw);
                    canvas.setAttributeNode(anh);
                    ctx.drawImage(that, 0, 0, w, h);
                    // 图像质量：小于0.3的话，可能就开始失真严重了
                    if (obj.quality && obj.quality <= 1 && obj.quality > 0) {
                        quality = obj.quality;
                    }
                    // quality = obj.quality;
                    // quality值越小，所绘制出的图像越模糊
                    let base64 = canvas.toDataURL('image/jpeg', quality);
                    //压缩完成执行回调
                    callback(base64);
                };
                image.src = e.target.result // 必须赋值给src属性，比如img的onload都不执行
            };
            reader.readAsDataURL(fileObj);
        } catch (e) {
            console.error('压缩失败');
            // 不压缩
            directTurnIntoBase64(fileObj, callback);
        }

    } else {
        // 小于1M不压缩
        directTurnIntoBase64(fileObj, callback);
    }
};

/**
 * photoCompress会获取到图片的base64，然后去调用canvasDataURL对图片进行压缩
 * @param file [type: object] [文件(类型是图片格式)]
 * @param w  [type: object] [文件压缩的后宽度，宽度越小，字节越小，这里其实是对象，比如{quality:0.7}，设置压缩后的质量]
 * @param callback [type: fn] [回调函数，比如调用上传接口]
 * 注：quality被限制最小为0.3了，因为小于0.3的话，图片就开始失真了！
 */
export const photoCompress = function (file, w, callback) {
    if (!file) {
        console.error('file有问题，不是对象吧？');
        return
    }
    let ready = new FileReader();
    /*开始读取指定的Blob对象或File对象中的内容. 当读取操作完成时,readyState属性的值会成为DONE,如果设置了onloadend事件处理程序,则调用之.同时,result属性中将包含一个data: URL格式的字符串以表示所读取文件的内容.*/
    ready.readAsDataURL(file);
    ready.onload = function () {
        let path = this.result;
        canvasDataURL(path, w, callback)
    }
};

/**
 * 压缩图片至文件
 * @param {Object} file
 * @param {Object} obj
 * @param {Object} callback
 */
export const photoCompressToFile = function (file, obj, callback) {
    if (!file) {
        console.error('file有问题，不是对象吧？');
        return
    }
    if (file.size / 1024 > obj.minSize) {
        // 超过大小
        photoCompress(file, obj, (base64Img) => {
            let newFile = dataURLtoFile(base64Img, file.name)
            callback(newFile)
        }, () => {
            // 图片经过多次压缩，还是太大了，提示用户
            console.error('抱歉，图片太大');
        })
    } else {
        callback(file)
    }
}

/**
 * canvasDataURL会去压缩图片
 * @param path [type: string] [是一个base64的字符串，这里一般会由photoCompress函数传入]
 * @param obj [type: object] [比如传入{quality:0.7, minSize: 1000, minQuality: 0.1}，分别设置压缩后的质量、图片大小的最小值、图片质量的最小值]
 * @param callback  [type: fn] [回调函数，比如调用上传接口]
 * @param errorCallback  [type: fn] [回调函数，因图片太大而获取图片失败的情况]
 * 注：现在最小限制以minQuality为准，minSize只是辅助，如果需求修改为必须小于限制值minSize，就在第二个判断里调用errorCallback；
 * 注：如果直接使用base64格式上传，content-length会比使用File对象格式上传大一些；
 */
const canvasDataURL = function (path, obj, callback, errorCallback) {
    let img = new Image();
    let minSize = obj.minSize; // 图片大小限制，不传就没限制
    let minQuality = obj.minQuality || 0.1; // 限制最小的图片质量quality
    img.src = path;
    img.onload = function () {
        if (obj.quality < minQuality) {
            // todo:quality小于minQuality了，证明图片太大，可以在这里告知用户图片太大了！
            // 由于下面代码有判断了，这里不会被执行的
            errorCallback && errorCallback();
            return
        }
        let quality = 0.7;  // 默认图片质量为0.7，而且必须大于0，否则强制为默认值
        // 图像质量：quality值越小，所绘制出的图像越模糊，小于0.3的话，可能就开始失真严重了
        if (obj.quality && obj.quality <= 1 && obj.quality > 0) {
            quality = obj.quality
        }
        let that = this;
        // 默认按比例压缩
        let w = that.width,
            h = that.height,
            scale = w / h;
        w = obj.width || w;
        h = obj.height || (w / scale);
        //生成canvas
        let canvas = document.createElement('canvas');
        let ctx = canvas.getContext('2d');
        // 创建属性节点
        let anw = document.createAttribute("width");
        anw.nodeValue = w;
        let anh = document.createAttribute("height");
        anh.nodeValue = h;
        canvas.setAttributeNode(anw);
        canvas.setAttributeNode(anh);
        ctx.drawImage(that, 0, 0, w, h);

        let base64 = canvas.toDataURL('image/jpeg', quality);
        // 回调函数返回base64的值
        // callback(base64);

        // 判断压缩后的图片是否超过限制值minSize，但quality不要小于minQuality，不然失真非常严重
        let size = convertBase64UrlToBlob(base64).size;
        if (size / 1024 > minSize && quality > minQuality) {
            // 如果压缩后还是大于限制值minSize，且quality还大于minQuality，那就再压缩：发现不能使用之前压缩后获得的base64去压缩，没效果，所以要重新传入quality
            let newQuality = (quality * 10 - 2) / 10; // js还是不要使用浮点数计算了
            canvasDataURL(path, {
                quality: newQuality,
                minSize: minSize,
                minQuality: minQuality,
            }, callback)
        } else if (size / 1024 > minSize && quality === minQuality) {
            // 如果压缩后还是大于限制值minSize，但quality刚好等于minQuality，那就返回压缩后的base64吧
            // 但需求如果修改为必须小于限制值minSize，那这里就告知用户，调用errorCallback
            // errorCallback && errorCallback()
            callback(base64)
        } else {
            // 到这一步，证明图片大小不超过限制值minSize
            // 回调函数返回base64的值
            callback(base64)
        }
    }
};


/**
 * convertBase64UrlToBlob将base64的图片url数据转换为Blob
 * @param dataUrl [用url方式表示的base64图片数据]
 */
export const convertBase64UrlToBlob = function (dataUrl) {
    let arr = dataUrl.split(','), mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }
    return new Blob([u8arr], {type: mime});
};

/**
 * dataURLtoFile将base64的图片url数据转换为原来的File对象
 * @param dataUrl [用url方式表示的base64图片数据]
 */
export const dataURLtoFile = function (dataUrl, filename = 'file') {
    let arr = dataUrl.split(','), mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, {type: mime});
};


export default {
    cutImg,
    directTurnIntoBase64,
    compress,
    convertBase64UrlToBlob,
    photoCompress,
    canvasDataURL,
    dataURLtoFile,
    photoCompressToFile
}



// WEBPACK FOOTER //
// ./src/assets/js/util.js